export const contains = (a, b) => a.toLowerCase().includes(b.toLowerCase())